import { render, staticRenderFns } from "./TotalBlock.vue?vue&type=template&id=2cedc5fc"
import script from "./TotalBlock.vue?vue&type=script&lang=js"
export * from "./TotalBlock.vue?vue&type=script&lang=js"
import style0 from "./TotalBlock.vue?vue&type=style&index=0&id=2cedc5fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports